import { render, staticRenderFns } from "./trCanvas.vue?vue&type=template&id=cff61086&scoped=true&"
import script from "./trCanvas.vue?vue&type=script&lang=js&"
export * from "./trCanvas.vue?vue&type=script&lang=js&"
import style0 from "./trCanvas.vue?vue&type=style&index=0&id=cff61086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff61086",
  null
  
)

export default component.exports